/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Incomplete_Confirm_Documents_GroupInputs */

const en_case_create_incomplete_confirm_documents_group = /** @type {(inputs: Case_Create_Incomplete_Confirm_Documents_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

const pt_br2_case_create_incomplete_confirm_documents_group = /** @type {(inputs: Case_Create_Incomplete_Confirm_Documents_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Case_Create_Incomplete_Confirm_Documents_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_incomplete_confirm_documents_group = /** @type {((inputs?: Case_Create_Incomplete_Confirm_Documents_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Incomplete_Confirm_Documents_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_incomplete_confirm_documents_group(inputs)
	return pt_br2_case_create_incomplete_confirm_documents_group(inputs)
});